<div class="mb-6 text-left">
  <header class="mb-6">
    <div class="text-3xl font-bold">{{ title }}</div>
    @if (subtitle !== '') {
      <div class="mt-2 leading-tight text-secondary">
        <span>
          <!-- {{ subtitle }} -->
          Pre-seleccionamos los mejores fondos
          <mat-icon
            class="text-base text-inherit relative icon-size-4 -bottom-[3px] cursor-pointer"
            [svgIcon]="'mat_outline:help_outline'"
            (click)="openHelpModal(helpTemplate)"
          >
          </mat-icon
          >, pero puedes agregar más
          <span bp-link (click)="onShowNonDefaultFundsChange()">aquí</span>.
        </span>
        @if (isChangePortfolioFlow) {
          <span>
            También puedes elegir alguno de nuestros
            <span bp-link class="mb-3" (click)="onChooseBpStrategyChange.emit()">
              portafolios optimizados por expertos.
            </span>
          </span>
        }
      </div>
    }
  </header>

  <div class="flex flex-col w-full h-full gap-4 md:flex-row">
    <div class="w-full md:w-[55%]">
      <div bp-card class="overflow-visible">
        <div bp-title-card class="pb-4">Clases de activos</div>
        @for (item of currentSubCategoryWithCustomFunds; track item) {
          <div class="mb-5">
            <bp-custom-portfolio-card
              [title]="item.category.categoryDisplayName!"
              [fundsDetail]="item"
              [currentCategoryFundAdded]="currentCategoryFundAdded"
              [currentCategoryFundRemoved]="currentCategoryFundRemoved"
              (onFormGroupChange)="onFormGroupChangeEvent($event)"
              (onFundsDetailChange)="onFundsDetailChangeEvent($event)"
              (onFundDelete)="onFundDeleteEvent($event)"
              (openFundDetail)="openFundDetail.emit($event)"
            >
            </bp-custom-portfolio-card>
          </div>
        }

        <div class="py-2 pr-0">
          <div class="flex flex-row justify-between">
            <div class="flex flex-row items-center">
              <span #boxLabel class="my-auto"> Caja </span>

              <mat-icon
                matSuffix
                matTooltipPosition="right"
                (click)="tooltipCaja.toggle()"
                #tooltipCaja="matTooltip"
                matTooltip="Cuando inviertes en cualquier portafolio, aproximadamente el 1% de tu dinero queda en caja, para así tener la liquidez para poder ir cobrando las comisiones pactadas."
                class="flex flex-col justify-center text-base cursor-pointer text-inherit align-center"
                >help_outline</mat-icon
              >
            </div>

            <span> 1% </span>
          </div>
        </div>
        <mat-divider> </mat-divider>
        <div class="hidden px-0 pt-2 pb-0 md:block">
          <div class="flex flex-row items-center justify-between pb-4">
            <span bp-link class="text-left" (click)="resetValues()">
              Restablecer porcentajes
              <!-- <span *ngIf="!(portfolio?.userId && portfolio?.userId?.value == goal?.userId)"
                >recomendados</span
                > -->
            </span>
            <span class="font-semibold text-right">Total: {{ sumValue + 1 }}%</span>
          </div>
          <div class="flex flex-col-reverse gap-2 mt-1">
            <div>
              <button
                mat-flat-button
                color="primary"
                class="w-full"
                [disabled]="sumValue !== 99 || form.status === 'INVALID'"
                (click)="onAcceptPortfolio()"
                [attr.data-cy]="'cg-new-goalCustomPortfolio-btn-continue-desktop'"
              >
                Usar este portafolio
              </button>
              @if (sumValue + 1 > 100) {
                <mat-error class="mt-1 text-base text-center"
                  >Los porcentajes no pueden superar el 100%</mat-error
                >
              }
            </div>
            @if (showNonDefaultFundsButton) {
              <button
                mat-stroked-button
                (click)="onShowNonDefaultFundsChange()"
                class="flex w-full gap-2"
              >
                <mat-icon [svgIcon]="'mat_outline:add'"></mat-icon>
                Agregar inversiones
              </button>
            }
          </div>
        </div>
        <div class="result-section" stickyClass="result-section--sticky">
          <div class="block pt-2 pb-0 bg-white md:hidden" #sticky>
            <div class="mx-0">
              <div class="flex flex-row items-center justify-between pb-4">
                <span
                  bp-link
                  class=""
                  (click)="resetValues()"
                  id="cg-new-goalCustomPortfolio-btn-reset"
                  [attr.data-cy]="'cg-new-goalCustomPortfolio-btn-reset'"
                >
                  Restablecer porcentajes
                  <!-- <span
                    *ngIf="
                      !(goal?.portfolio?.userId && goal?.portfolio?.userId?.value == goal.userId)
                    "
                      >recomendados</span
                      > -->
                </span>
                <span class="font-semibold text-right">Total: {{ sumValue + 1 }}%</span>
              </div>
              <div class="flex flex-col-reverse gap-2 mb-2">
                <div>
                  <button
                    mat-flat-button
                    color="primary"
                    class="w-full"
                    [disabled]="sumValue !== 99 || form.status === 'INVALID'"
                    (click)="onAcceptPortfolio()"
                    id="cg-new-goalCustomPortfolio-btn-continue"
                    [attr.data-cy]="'cg-new-goalCustomPortfolio-btn-continue-responsive'"
                  >
                    Usar este portafolio
                  </button>
                  @if (sumValue + 1 > 100) {
                    <mat-error class="mt-1 text-center"
                      >Los porcentajes no pueden superar el 100%</mat-error
                    >
                  }
                </div>
                @if (showNonDefaultFundsButton) {
                  <button
                    mat-stroked-button
                    (click)="onShowNonDefaultFundsChange()"
                    class="flex w-full gap-2"
                  >
                    <mat-icon [svgIcon]="'mat_outline:add'"></mat-icon>
                    Agregar inversiones
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- dasdas -->
    </div>
    <div class="w-full md:w-[45%]">
      <div bp-card>
        <span bp-title-card> Análisis del portafolio</span>
        <app-portfolio-composition-graph
          [title]="compositionGraphTitle"
          [compositions]="compositionsGraph"
        ></app-portfolio-composition-graph>
        <div class="mt-2 mb-4">
          <div class="flex flex-row justify-between">
            <div class="flex flex-row items-center">
              <span class="">Nivel de riesgo </span>
              <!-- matTooltip="0% acciones = Muy conservador
                % acciones entre 1 y 25 = Conservador
                % acciones entre 26 y 50 = Moderado
                % acciones entre 51 y 75 = Arriesgado
                % acciones entre 76 y 100 = Muy arriesgado"
                    class="px-1 pt-1 cursor-pointer position-relative ahorro-sugerido-icon d-inline-flex" -->
              <mat-icon
                matTooltipPosition="above"
                (click)="tooltipRiesgo.toggle()"
                #tooltipRiesgo="matTooltip"
                matTooltip="El nivel de riesgo está calculado en base al % de renta fija y variable de tu portafolio"
                class="text-base cursor-pointer text-inherit"
                >help_outline</mat-icon
              >
            </div>

            <span class="font-semibold">
              {{ riskLevel?.title }}
            </span>
          </div>
        </div>
        <mat-divider> </mat-divider>
        <div class="my-4">
          <span class="">Asignación de activos </span>
          <div class="flex mt-3 bg-gray-100">
            @for (gc of groupCategoryPercentages; track gc) {
              <span
                class="flex h-5 cursor-pointer"
                [style.backgroundColor]="gc.color"
                [style.width]="(gc.percentage * 100) / 99 + '%'"
                [matTooltip]="gc.groupCategoryTitle + ' (' + gc.percentage + '%)'"
                #groupCategoryTooltip="matTooltip"
                (click)="groupCategoryTooltip.toggle()"
              ></span>
            }
          </div>

          <!-- <div class="flex flex-row justify-between mt-2 text-secondary f-12">
                  <span> Acciones ({{ stockBondsPercentages.stockPercentage }}%) </span>
                  <span> Renta Fija ({{ stockBondsPercentages.bondsPercentage }}%) </span>
                </div> -->
        </div>
        <mat-divider> </mat-divider>
        <div class="my-4">
          <span class="">Exposición geográfica</span>

          <div class="flex mt-3 bg-gray-100">
            <span
              class="flex h-5 col-span-3 rounded-s-sm"
              [style.backgroundColor]="colorService.getGreen(0)"
              #tooltipNational="matTooltip"
              [matTooltip]="
                'Nacional (' + nationalInternationalPercentages.nationalPercentage + '%)'
              "
              (click)="tooltipNational.toggle()"
              [style.width]="nationalInternationalPercentages.nationalPercentage + '%'"
            ></span>
            <span
              class="flex h-5 col-span-3 rounded-e-sm"
              #tooltipInternational="matTooltip"
              [matTooltip]="
                'Internacional (' + nationalInternationalPercentages.internationalPercentage + '%)'
              "
              (click)="tooltipInternational.toggle()"
              [style.backgroundColor]="colorService.getBlue(0)"
              [style.width]="nationalInternationalPercentages.internationalPercentage + '%'"
            ></span>
          </div>
          <!-- <div class="mt-3 progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  [style.backgroundColor]="getStockColor(0)"
                  [style.width]="nationalInternationalPercentages.nationalPercentage + '%'"
                  aria-valuenow="89"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
                <div
                  class="progress-bar progress-bar-dark"
                  role="progressbar"
                  [style.backgroundColor]="getBondColor(0)"
                  [style.width]="nationalInternationalPercentages.internationalPercentage + '%'"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div> -->

          <!-- <div class="flex flex-row justify-between mt-2 text-secondary ">
              <span> Nacional ({{ nationalInternationalPercentages.nationalPercentage }}%) </span>
              <span>
                Internacional ({{ nationalInternationalPercentages.internationalPercentage }}%)
              </span>
            </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #helpTemplate>
  <div class="flex flex-col gap-3">
    <p>
      Betterplan no sólo te da acceso a la plataforma de fondos más completa y exclusiva del
      mercado, sino que también gracias a nuestra <b>independencia</b>, somos capaces de analizar y
      <b> recomendarte los mejores fondos sin conflictos de interés.</b>
    </p>
    <!-- <i class="text-lg text-center far fa-envelope text-primary"></i> -->
    <p>
      Para ayudarte a crear un <b>portafolio perfecto</b>, primero encontrarás una selección de
      fondos para casa clase de activos (acciones, renta fija, alternativos). El listado de fondos
      elegidos es el resultado de un proceso riguroso realizado por nuestro comité de inversiones,
      donde se analiza cada fondo en base a su trayectoria, desempeño, tamaño, liquidez y costo,
      entre otras características.
    </p>
    <p>
      Analizamos en detalle cada fondo y dependiendo de la evolución de estos, los fondos
      recomendados para cada clase de activos van cambiando en el tiempo.
    </p>
    <p>
      De todas maneras, los clientes de Betterplan tienen disponibles cientos de fondos y acciones
      para explorar y sumar a sus portafolios en caso de que quieran sumar opciones de inversión
      adicionales a los fondos recomendados.
    </p>
  </div>
</ng-template>
